(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_179a021"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nc-bestsellers-carousel')) {
  customElements.define('nc-bestsellers-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nc-bs__track');
      if (!this.track || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.controls = this.querySelector('.nc-bs__controls');
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.progress = this.querySelector('.nc-bs__progress');
      this.thumb = this.progress.querySelector('span');
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const card = this.track.querySelector('.nc-bs__card');
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: (button === this.next ? 1 : -1) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, { signal });
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflowing = max > 2;
        const position = Math.max(0, Math.min(max, this.track.scrollLeft));
        this.controls.hidden = !overflowing;
        this.progress.hidden = !overflowing;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
        const fraction = Math.min(1, this.track.clientWidth / Math.max(1, this.track.scrollWidth));
        const width = Math.max(16, 100 * fraction);
        this.thumb.style.width = width + '%';
        this.thumb.style.transform = 'translateX(' + (max > 0 ? (position / max) * (100 - width) / width * 100 : 0) + '%)';
      };
      this.track.addEventListener('scroll', this.update, { passive: true, signal });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
